import { RouteLocationNormalizedGeneric } from 'vue-router';
import { useLayoutStore } from '~/stores/useLayoutStore';
import { useCompanyStore } from '~/stores/useCompanyStore';
import { storeToRefs } from 'pinia';
import useTranslator from '~/composables/useTranslator';
import { CompanyDocument } from '~/utils/CompanyDocument';
import { useAuthStore } from '~/stores/useAuthStore';

function layoutMiddleware(
  to: RouteLocationNormalizedGeneric,
  from: RouteLocationNormalizedGeneric,
) {
  const LAYOUT_STORE = useLayoutStore();
  const COMPANY_STORE = useCompanyStore();
  const AUTH_STORE = useAuthStore();
  const { companyName } = storeToRefs(COMPANY_STORE);
  const { session } = storeToRefs(AUTH_STORE);

  function handleBanner(to: RouteLocationNormalizedGeneric) {
    const bannerContentByRouteName = {
      dashboard: {
        title: useTranslator('MY_SCANSOURCE'),
        subtitle: useTranslator('BANNER_DEFAULT_SUBTITLE'),
      },

      'register-user-invitationCode': {
        title: useTranslator('INVITE_USER.TITLE'),
        subtitle: useTranslator('INVITE_USER.SUBTITLE'),
      },

      'register-master-invitationCode': {
        title: useTranslator('INVITE_USER.TITLE'),
        subtitle: useTranslator('INVITE_USER.SUBTITLE'),
      },

      'access-control-solicitationCode': {
        title: useTranslator('Concessão de Acesso'),
        subtitle: useTranslator(''),
      },

      'users-invite-confirm': {
        title: useTranslator('NEXT_STEPS.BANNER.TITLE'),
        subtitle: useTranslator('NEXT_STEPS.BANNER.SUBTITLE'),
      },
    };

    if (to.name === 'dashboard') {
      setTimeout(() => {
        LAYOUT_STORE.setBannerTitle(bannerContentByRouteName['dashboard'].title);
        LAYOUT_STORE.setBannerSubtitle(bannerContentByRouteName['dashboard'].subtitle);
      }, 100);
    }

    if (to.name !== 'dashboard') {
      switch (to.name) {
        case 'register-user-invitationCode':
          setTimeout(() => {
            LAYOUT_STORE.setBannerTitle(
              bannerContentByRouteName['register-user-invitationCode'].title,
            );
            LAYOUT_STORE.setBannerSubtitle(
              bannerContentByRouteName['register-user-invitationCode'].subtitle,
            );
          }, 100);
          break;

        case 'register-master-invitationCode':
          setTimeout(() => {
            LAYOUT_STORE.setBannerTitle(
              bannerContentByRouteName['register-master-invitationCode'].title,
            );
            LAYOUT_STORE.setBannerSubtitle(
              bannerContentByRouteName['register-master-invitationCode'].subtitle,
            );
          }, 100);
          break;

        case 'access-control-solicitationCode':
          setTimeout(() => {
            LAYOUT_STORE.setBannerTitle(
              bannerContentByRouteName['access-control-solicitationCode'].title,
            );
            LAYOUT_STORE.setBannerSubtitle(
              bannerContentByRouteName['access-control-solicitationCode'].subtitle,
            );
          }, 100);
          break;

        case 'users-invite-confirm':
          setTimeout(() => {
            LAYOUT_STORE.setBannerTitle(bannerContentByRouteName['users-invite-confirm'].title);
            LAYOUT_STORE.setBannerSubtitle(
              bannerContentByRouteName['users-invite-confirm'].subtitle,
            );
          }, 100);
          break;

        default:
          setTimeout(() => {
            LAYOUT_STORE.setBannerTitle(companyName.value ?? 'MyScanSource');
            LAYOUT_STORE.setBannerSubtitle(
              CompanyDocument(session.value.currentEconomicGroupMember).masked,
            );
          }, 100);
          break;
      }
    }
  }

  function togglePageLabel(to: RouteLocationNormalizedGeneric) {
    const isVisibleLabelRoute = new Set()
      .add('dashboard')
      .add('register-user-invitationCode')
      .add('register-master-invitationCode')
      .add('access-control-solicitationCode')
      .add('users-invite')
      .add('help')
      .has(String(to.name));

    if (isVisibleLabelRoute) LAYOUT_STORE.showPageLabel();
    else LAYOUT_STORE.hidePageLabel();
  }

  function handleFloatingMenu(to: RouteLocationNormalizedGeneric) {
    const hiddenMenuRoute = new Set()
      .add('index')
      .add('access-control')
      .add('access-control-solicitationCode')
      .add('goodbye')
      .add('help')
      .add('not-allowed')
      .add('register')
      .add('register-user-invitationCode')
      .add('next-steps')
      .add('register-master-invitationCode')
      .add('unavailable')
      .add('welcome')
      .add('welcome-back');

    if (!AUTH_STORE.authenticated) hiddenMenuRoute.add('users-invite-confirm');

    const isHiddenMenuRoute = hiddenMenuRoute.has(String(to.name));

    if (isHiddenMenuRoute) LAYOUT_STORE.hideFloatingNavbar();
    else LAYOUT_STORE.showFloatingNavbar();
  }

  togglePageLabel(to);
  handleBanner(to);
  handleFloatingMenu(to);
}

export { layoutMiddleware };
